<div [className]="(isMobile)?'modal1MainMob modal1Main':'modal1Main'" style="min-height: 650px;" >
    <div class="modalHeader">
      <div class="modNexPre">
        <a href="javascript:void(0)" *ngIf="prePlayer != 0" (click)="changePlayerData(prePlayer)"><i class="zmdi zmdi-chevron-left "></i> <span class="pL10">PREVIOUS PLAYER</span></a>
        <a href="javascript:void(0)" *ngIf="nextPlayer != 0" (click)="changePlayerData(nextPlayer)"><span class="pR10">NEXT PLAYER</span> <i class="zmdi zmdi-chevron-right"></i></a>
      </div> 
      <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
    </div>

  <div>
    <perfect-scrollbar class=" maxHei600" [config]="{}" style="max-width: 100%;">
      <div class="scorePopupTop" *ngIf="summaryInfo">
        <div class="row disFlex">
          <div class="col s12 m4 l4 lx4 align-self-center">
            <div class="scorePopupTopLe">
              <div class="userImg dynamicBg" [ngStyle]="{'background-image':'url('+assetUploadURL+'/players/'+playerDetail.profile_pic+')'}"></div>
              <span class="plyNAme">{{playerDetail.first_name+' '+playerDetail.last_name}} {{(playerDetail.game_id != 5)?"#"+summaryInfo.p_uniform:''}}</span>
              <span class="plyPos">{{playerDetail.postionsName }}</span>
              <span class="plyTeam">{{((playerDetail.game_id != 5)?summaryInfo?.p_team:summaryInfo?.p_nationality) }}</span>
            </div>
          </div>
          <div class="col s12 m4 l4 lx4 text-center align-self-center">
            <div class="scorePopupTopmidd" *ngIf="summaryInfo.nextGameData.date_time">
              {{ "Next "+((playerDetail.game_id != 5)?'Game':'Outing')+": "+((playerDetail.game_id == 5)?summaryInfo?.nextGameData?.name:p_loc)+((playerDetail.game_id != 5)?summaryInfo.nextGameData.team_abbr:'')+" ("+summaryInfo.nextGameData.date_time+")"}}
            </div>
          </div>
          <div class="col s12 m4 l4 lx4 align-self-center">
            <div class="scorePopupTopright " *ngIf="draftSelectBox.length > 0">
              <button mat-raised-button color="primary" [ngClass]="['draftBtn', 'float-right',(showDraftBox && draftSelectBox && draftSelectBox.length > 0 && !isAutoDraft)?'glowing':'',(showDraftBox && draftSelectBox && draftSelectBox.length > 0 && !isAutoDraft)?'draftBtnHover':'']" [ngStyle]="{'background-color':(showDraftBox && draftSelectBox && draftSelectBox.length > 0 && !isAutoDraft)?'#5cb85d':'#9898987a'}" (click)="(showDraftBox && !isAutoDraft)?playerDraft():''">{{ (!isAutoDraft)?'Draft':'Auto Draft'}}</button> 
              <div class="draftAsInput float-right" *ngIf="draftSelectBox && draftSelectBox.length > 0 && !isAutoDraft">
                <label class="">Draft As:</label>
                <mat-form-field class="form-control ">
                  <mat-select [(ngModel)]="selected">
                    <mat-option *ngFor="let rec of draftSelectBox" [value]="rec.key">
                      {{rec.value}}
                    </mat-option> 
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <div class="invite_PanelTab scoreTab">
        <mat-tab-group class="dtable" [selectedIndex]="0" (selectedTabChange)="changeTabData($event.index)">
          <mat-tab>
            <ng-template mat-tab-label class="" >
              Summary
            </ng-template>  
            <div>
              <div class="scoreTable"> 
                <perfect-scrollbar class=" maxHei700" [config]="{}" style="max-width: 100%;">
                <table cellspacing="0" cellpadding="0" *ngIf="summaryInfo && summaryInfo.summaryTable"> 
                  <thead class="logTabHead" *ngIf="summaryInfo.summaryGroupTable">
                    <tr class="logTbleTop">
                      <td  *ngFor="let groupRec of summaryInfo.summaryGroupTable;let i = index" [attr.colspan]="groupRec.colspan" >
                          <div *ngIf="groupRec.label" class="logTabPos" [ngStyle]="{'background-color': ((i==2)?'#ffb3ba':((i==3)?'#b0e3e0':((i>3)?'#bbb2f6':'#ffb3ba')))}">{{groupRec.label | titlecase}}</div> 
                      </td> 
                    </tr>
                  </thead>
                  <thead class="logTabHead1" *ngIf="summaryInfo.summaryTheadTable">
                    <tr>
                      <th *ngFor="let thRec of summaryInfo.summaryTheadTable;let i = index"  [attr.colspan]="thRec.colspan" title="{{thRec.title}}">{{ thRec.label}}</th> 
                    </tr>
                  </thead> 
                      <tbody *ngIf="summaryInfo.summaryTable">
                        <tr *ngFor="let trRec of summaryInfo.summaryTable">
                          <td *ngFor="let tdRec of trRec.column;let i = index" [className]="((i == 0)?'text-left ':((tdRec.title == 'L')?'red':((tdRec.title == 'W')?'green':'')))" [attr.colspan]="tdRec.colspan">
                            <strong *ngIf="tdRec.title == 'fpts';else commonTd">{{tdRec.label}}</strong>
                            <ng-template #commonTd>
                              {{tdRec.label}}
                            </ng-template> 
                          </td> 
                          <!-- <td class="green">W(122-120)</td> -->
                          <!-- <td><strong>51.00</strong></td> --> 
                        </tr>
                      </tbody>
                      <tfoot class="" *ngIf="summaryInfo.summaryTfootTable">
                        <tr *ngFor="let tfRec of summaryInfo.summaryTfootTable;let j = index" [className] = "(j==1)?'tFootEnd':''" >
                          <td *ngFor="let tfdRec of tfRec.column;let i = index" [attr.colspan]="tfdRec.colspan" [className]="(i == 0)?'blue text-left':''">{{tfdRec.label}}</td> 
                        </tr> 
                      </tfoot>  
                </table> 
                </perfect-scrollbar>
                <div *ngIf="summaryInfo && summaryInfo.summaryTable == ''" class="text-center">No record found</div>
              </div>
          
              <div class="scoreNews">
                <div class="row disFlex">
                  <div class="col s12 m6 l6 lx4 align-self-center">
                      <h4>Recent News</h4>
                  </div>
                  <div class="col s12 m6 l6 lx4 align-self-center">
                      <!-- <div class="text-right pB20" *ngIf="summaryInfo && summaryInfo.summaryTable != ''" >
                          <button mat-stroked-button class="logBtn" (click)="changeTab(1)">VIEW FULL GAME LOG</button>
                        </div> -->
                    
                  </div>

                </div>
                
              
                <mat-accordion *ngIf="summaryInfo && summaryInfo.news">
                  <mat-expansion-panel *ngFor="let news of summaryInfo.news;let i =index" [expanded]='(i == 0)?true:false'>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{news.created}} | {{news.summary}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="recentNews">
                      {{news.detail}}
                    </div>
                  </mat-expansion-panel> 
                </mat-accordion> 
                <div *ngIf="summaryInfo && summaryInfo.news.length == 0" class="text-center">No record found</div>
              </div>
              <div class="text-center " *ngIf="summaryInfo && summaryInfo.news.length != 0">
                <button mat-stroked-button class="logBtn" (click)="changeTab(3)">View More news</button>
              </div>
            </div> 
          </mat-tab>
    
          <mat-tab >
            <ng-template mat-tab-label class="dtableCell" >
              Game Log
            </ng-template> 
            <div>
              <div class="scoreTable"> 
                  <perfect-scrollbar class=" maxHei700" [config]="{}" style="max-width: 100%;">
                  <table cellspacing="0" cellpadding="0" *ngIf="gameLogInfo && gameLogInfo.summaryTable"> 
                    <thead class="logTabHead" *ngIf="gameLogInfo.summaryGroupTable">
                      <tr class="logTbleTop">
                        <td  *ngFor="let groupRec of gameLogInfo.summaryGroupTable;let i = index" [attr.colspan]="groupRec.colspan" >
                            <div *ngIf="groupRec.label" class="logTabPos" [ngStyle]="{'background-color': ((i==1)?'#ffb3ba':((i==2)?'#b0e3e0':((i>2)?'#bbb2f6':'#ffb3ba')))}">{{groupRec.label | titlecase}}</div> 
                        </td> 
                      </tr>
                    </thead>
                    <thead class="logTabHead1" *ngIf="gameLogInfo.summaryTheadTable">
                      <tr>
                        <th *ngFor="let thRec of gameLogInfo.summaryTheadTable;let i = index"  [attr.colspan]="thRec.colspan" title="{{thRec.title}}">{{ thRec.label}}</th> 
                      </tr>
                    </thead> 
                    <tbody *ngIf="gameLogInfo.summaryTable">
                      <tr *ngFor="let trRec of gameLogInfo.summaryTable">
                        <td *ngFor="let tdRec of trRec.column;let i = index" [className]="((i == 0)?'text-center ':((tdRec.title == 'L')?'red':((tdRec.title == 'W')?'green':'')))" [attr.colspan]="tdRec.colspan">
                          <strong *ngIf="tdRec.title == 'fpts';else commonTd">{{tdRec.label}}</strong>
                          <ng-template #commonTd>
                            {{tdRec.label}}
                          </ng-template> 
                        </td>  
                      </tr>
                    </tbody>
                    <tfoot class="" *ngIf="gameLogInfo.summaryTfootTable">
                      <tr *ngFor="let tfRec of gameLogInfo.summaryTfootTable;let j = index" [className] = "(j==1)?'tFootEnd':''" >
                        <td *ngFor="let tfdRec of tfRec.column;let i = index" [attr.colspan]="tfdRec.colspan" [className]="(i == 0)?'blue text-left':''">{{tfdRec.label}}</td> 
                      </tr> 
                    </tfoot>  
                  </table>
                  </perfect-scrollbar>
                  <div *ngIf="gameLogInfo && gameLogInfo.summaryTable == ''" class="text-center">No record found</div>
              </div>
            </div> 
          </mat-tab>
    
          <mat-tab >
            <ng-template mat-tab-label class="dtableCell"  >
              Career Stats
            </ng-template>  
              <div>
                <div class="scoreTable">
                    <perfect-scrollbar class=" maxHei700" [config]="{}" style="max-width: 100%;">
                  <table cellspacing="0" cellpadding="0" *ngIf="careerStatsInfo && careerStatsInfo.summaryTable"> 
                    <thead class="logTabHead" *ngIf="careerStatsInfo.summaryGroupTable">
                      <tr class="logTbleTop">
                        <td  *ngFor="let groupRec of careerStatsInfo.summaryGroupTable;let i = index" [attr.colspan]="groupRec.colspan" >
                            <div *ngIf="groupRec.label" class="logTabPos" [ngStyle]="{'background-color': ((i==1)?'#ffb3ba':((i==2)?'#b0e3e0':((i>2)?'#bbb2f6':'#ffb3ba')))}">{{groupRec.label | titlecase}}</div> 
                        </td> 
                      </tr>
                    </thead>
                    <thead class="logTabHead1" *ngIf="careerStatsInfo.summaryTheadTable">
                      <tr>
                        <th *ngFor="let thRec of careerStatsInfo.summaryTheadTable;let i = index"  [attr.colspan]="thRec.colspan" title="{{thRec.title}}">{{ thRec.label}}</th> 
                      </tr>
                    </thead> 
                    <tbody *ngIf="careerStatsInfo.summaryTable">
                      <tr *ngFor="let trRec of careerStatsInfo.summaryTable">
                        <td *ngFor="let tdRec of trRec.column;let i = index" [className]="((i == 0)?'text-center ':((tdRec.title == 'L')?'red':((tdRec.title == 'W')?'green':'')))" [attr.colspan]="tdRec.colspan">
                          <strong *ngIf="tdRec.title == 'fpts';else commonTd">{{tdRec.label}}</strong>
                          <ng-template #commonTd>
                            {{tdRec.label}}
                          </ng-template> 
                        </td>  
                      </tr>
                    </tbody>
                    <tfoot class="" *ngIf="careerStatsInfo.summaryTfootTable">
                      <tr class="tFootEnd" >
                        <td *ngFor="let tfdRec of careerStatsInfo.summaryTfootTable;let i = index" [attr.colspan]="tfdRec.colspan" [className]="(i == 0)?'blue text-center':''">{{tfdRec.label}}</td> 
                      </tr> 
                    </tfoot>  
                  </table> 
                  </perfect-scrollbar>
                  <div *ngIf="careerStatsInfo && careerStatsInfo.summaryTable == ''" class="text-center">No record found</div>
                </div>
              </div> 
          </mat-tab>
    
          <mat-tab>
            <ng-template mat-tab-label class="dtableCell" > 
              News
            </ng-template> 
            <div class="scoreNews">
              <mat-accordion *ngIf="newsInfo">
                <mat-expansion-panel *ngFor="let news of newsInfo;let i =index" [expanded]='(i == 0)?true:false'>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{news.created}} | {{news.summary}}
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <div class="recentNews">
                    {{news.detail}}
                  </div>
                </mat-expansion-panel> 
              </mat-accordion> 
              <div *ngIf="newsInfo.length == 0" class="text-center">No record found</div> 
            </div> 
          </mat-tab>
    
        </mat-tab-group>
    
      </div>
    
    </perfect-scrollbar>
  </div>
  </div> 
